var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-card',{staticClass:"p-3"},[_c('div',{staticClass:"xl:flex gap-5"},[_c('MapList',{staticClass:"p-5",staticStyle:{"flex":"1"},on:{"changeYear":_vm.onChangeYear}}),_c('MapLayout',{staticClass:"p-5",staticStyle:{"flex":"3"},attrs:{"year":_vm.year}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }